import { SiteIdOverrideConfig } from "stores/wizard/config";

// tslint:disable-next-line: variable-name
export const siteId4_fr_CA: SiteIdOverrideConfig = {
  thirdPartyPackage: {
    duration: {
      daysTextApi: "jours",
    },
    navigation: {
      tabTitleToken: "wizard.package.tab.title.variant.1.label",
    },
  },
};
